import ConnectionUnavailableError from './ConnectionUnavailableError'
import NotFoundError from './NotFoundError'
import NotSignedInError from './NotSignedInError'
import NotSupportedError from './NotSupportedError'
import PermissionDeniedError from './PermissionDeniedError'
import RequiresBasicAuthError from './RequiresBasicAuthError'
import TargetNotSupportedError from './TargetNotSupportedError'
import ValidationError from './ValidationError'
import WrongCredentialsError from './WrongCredentialsError'

export {
  ConnectionUnavailableError,
  NotFoundError,
  NotSignedInError,
  NotSupportedError,
  PermissionDeniedError,
  RequiresBasicAuthError,
  TargetNotSupportedError,
  ValidationError,
  WrongCredentialsError,
}
